/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

// https://docs.amplify.aws/lib/client-configuration/configuring-amplify-categories/q/platform/js/
const awsmobile = {
  aws_project_region: "ap-northeast-2",

  Auth: {
    region: "ap-northeast-2",
    userPoolId: "ap-northeast-2_bjCkJC9Lj", // Please change this value.
    userPoolWebClientId: "4k1ir4lijkt6jvn31og2pn7ug0", // Please change this value.
    identityPoolId: "ap-northeast-2:8dd47ed0-67fc-4bbc-91e4-9005519e40b0",
  },
  Storage: {
    AWSS3: {
      bucket: "ezwelliveprod-channelbackendstack-wa-ap-northeast-2-05182",
      region: "ap-northeast-2",
    },
  },
  aws_cloud_logic_custom: [
    {
      name: "MobileApiName",
      endpoint: "https://ezwel-api.livehyundai.com/client/",
      region: "ap-northeast-2",
    },
    {
      name: "LiveChannelApiName",
      endpoint: "https://ezwel-api.livehyundai.com/client/",
      region: "ap-northeast-2",
    },
    {
      name: "GameApiName",
      endpoint: "https://ezwel-api.livehyundai.com/client/",
      region: "ap-northeast-2",
    },
    {
      name: "StatisticApiName",
      endpoint: "https://ezwel-api.livehyundai.com/client/",
      region: "ap-northeast-2",
    },
    {
      name: "ChatApiName",
      // endpoint: "https://es4xiajn3g.execute-api.ap-northeast-2.amazonaws.com/Prod/",
      endpoint: "https://ezwel-api.livehyundai.com/chat/",
      region: "ap-northeast-2",
    },
    {
      name: "ChatInputApiName",
      // endpoint: "https://c4wcw7ak8a.execute-api.ap-northeast-2.amazonaws.com/Prod/",
      endpoint: "https://ezwel-api.livehyundai.com/chatInput/",
      region: "ap-northeast-2",
    },
    {
      name: "ChatMngApiName",
      // endpoint: "https://8o0h4yl0k3.execute-api.ap-northeast-2.amazonaws.com/Prod/",
      endpoint: "https://ezwel-api.livehyundai.com/chatMng/",
      region: "ap-northeast-2",
    },
  ],
};

export default awsmobile;
